import {
  ProductBuilderMachineContext,
  ProductBuilderMachineState,
} from '../types';
import { getCommonStatesFromProducts } from './getCommonStatesFromProducts';
import { getProductType } from './getProductType';
import { getStatesForProductType } from './getStatesForProductType';
import { lightGuardsStatePostProcess } from './lightGuards';
import { liningColourPostProcess } from './liningColour';
import { trackColourPostProcess } from './trackColor';
import { pullRodColourPostProcess } from './pullRodColour';
import { singleCordedWatson } from '../constants/states/rollerStates';

type GetStates = (
  context: ProductBuilderMachineContext,
) => ProductBuilderMachineState[];

export const getStates: GetStates = context => {
  const productType = getProductType(context);
  let rollerPremiumCorded = context.products.filter(
    ele =>
      ele.tags?.includes(`Material: ${context?.custom?.materialType}`) &&
      ele.tags?.includes(`${context?.custom?.colour}`) &&
      ele?.metafields?.supplier !== undefined,
  );

  let states = productType
    ? getStatesForProductType(productType)
    : getCommonStatesFromProducts(context.products);

  if (productType === 'Curtain') {
    // Get the current product based on selected color
    const currentProduct = context.products.find(product =>
      product.tags?.some(tag =>
        tag.toLowerCase().includes(context?.custom?.colour?.toLowerCase()),
      ),
    );

    // If we have a current product selected, check its metafields
    if (currentProduct) {
      const hasWandOption = currentProduct.metafields?.wand_option;

      if (!hasWandOption) {
        states = states.filter(state => state !== 'wand_option');
      }

      const hasPullRod = currentProduct.metafields?.pull_rod;

      if (!hasPullRod) {
        states = states.filter(state => state !== 'pullRod');
      }
    }

    // NEW: Remove wand_colour step if wand_option is not "yes"
    if (context.custom.wand_option != 'Yes') {
      states = states.filter(state => state !== 'wand_colour');
    }
  }

  if (
    productType === 'Roller Blind Essentials Chain' &&
    rollerPremiumCorded?.length > 0
  ) {
    states = [
      'materialType',
      'colour',
      'chainType',
      'bracketColour',
      'fitting',
      'measurements',
      'rollDirection',
      'chainPosition',
      'roomName',
      'complete',
    ];
  }

  if (
    productType === 'Roller Blind Single Chain' &&
    rollerPremiumCorded?.length > 0
  ) {
    states = singleCordedWatson;
  }

  if (productType) {
    states = lightGuardsStatePostProcess(productType, context, states);
    states = trackColourPostProcess(productType, context, states);
    states = liningColourPostProcess(productType, context, states);
    states = pullRodColourPostProcess(productType, context, states);
  }

  return states;
};
